import { createElement } from "react";
import React from "react";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { useCtx } from "./Context.jsx";
import { UpdatedTitle, Title as Title_1, NewTitle } from "./Shared/SharedModels.jsx";
import { SkeletonItem, Skeleton, Card, Caption1, Title3, DataGridCell, DataGridBody, DataGridHeader, DataGridHeaderCell, DataGridRow, DataGrid, createTableColumn as createTableColumn_2, Body1Strong, tokens, DialogBody, DialogActions, Input, Field, DialogContent, DialogTitle, DialogSurface, Button, DialogTrigger, Dialog } from "@fluentui/react-components";
import { createObj } from "./fable_modules/fable-library-js.4.29.0/Util.js";
import { SearchRegular, WarningFilled, DeleteRegular, SaveRegular, EditRegular, DismissRegular, AddRegular } from "@fluentui/react-icons";
import { toArray, take, length, tryHead, empty, singleton, append, delay, toList } from "./fable_modules/fable-library-js.4.29.0/Seq.js";
import { compare, isNullOrWhiteSpace } from "./fable_modules/fable-library-js.4.29.0/String.js";
import { defaultOf } from "./fable_modules/fable-library-js.4.29.0/Util.js";
import { map as map_1, singleton as singleton_1, ofArray } from "./fable_modules/fable-library-js.4.29.0/List.js";
import { reactApi as reactApi_1 } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { startAsPromise } from "./fable_modules/fable-library-js.4.29.0/Async.js";
import { toastServerError, Title } from "./ApiClient.jsx";
import { successToast, errorToast } from "./Toasts.jsx";
import { map, append as append_1 } from "./fable_modules/fable-library-js.4.29.0/Array.js";
import { SortDirection } from "./fable_modules/FS.FluentUI.3.0.0/Domain.fs.js";
import { dataGrid_items_Z6D8BD2B8 } from "./fable_modules/FS.FluentUI.3.0.0/Props2.fs.js";
import { some, unwrap } from "./fable_modules/fable-library-js.4.29.0/Option.js";
import { useEffectOnce } from "./fable_modules/Feliz.2.9.0/Internal.fs.js";
import { rangeDouble } from "./fable_modules/fable-library-js.4.29.0/Range.js";

function AddTitleDialog(addTitleDialogInputProps) {
    let elems_5, el_4, el_2, el, el_25, elems_4, props_36, el_6, el_13, elems_2, elems_1, el_11, el_23, elems_3, el_17, el_15, el_21, el_19, name_2, elemsToUse;
    const setTitles = addTitleDialogInputProps.setTitles;
    const titles = addTitleDialogInputProps.titles;
    const patternInput = reactApi.useState(false);
    const setIsOpen = patternInput[1];
    const patternInput_1 = reactApi.useState(false);
    const setCtx = useCtx()[1];
    let patternInput_3;
    const initial_2 = new NewTitle("");
    patternInput_3 = reactApi.useState(initial_2);
    const setForm = patternInput_3[1];
    const form = patternInput_3[0];
    const resetForm = () => {
        setForm(new NewTitle(""));
    };
    const el_27 = Dialog;
    return createElement(el_27, createObj(ofArray([["open", patternInput[0]], ["onOpenChange", (_arg, value_1_1) => {
        setIsOpen(value_1_1.open);
    }], (elems_5 = [(el_4 = DialogTrigger, createElement(el_4, {
        children: (el_2 = Button, createElement(el_2, {
            icon: (el = AddRegular, createElement(el, {})),
            iconPosition: "before",
            appearance: "primary",
            children: "Legg til",
        })),
    })), (el_25 = DialogSurface, createElement(el_25, createObj(ofArray([["style", {
        maxWidth: 400,
    }], (elems_4 = [(props_36 = ofArray([(el_6 = DialogTitle, createElement(el_6, {
        children: "Legg til tittel",
    })), (el_13 = DialogContent, createElement(el_13, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 5 + "px ",
    }], (elems_2 = [createElement("div", createObj(ofArray([["style", {
        minHeight: 80,
        width: 100 + "%",
    }], (elems_1 = [(el_11 = Field, createElement(el_11, createObj(toList(delay(() => append(singleton(["label", "Navn"]), delay(() => append(patternInput_1[0] ? append(singleton(["validationMessage", "Navn kan ikke være tomt"]), delay(() => singleton(["validationState", "error"]))) : empty(), delay(() => {
        let matchValue, el_8;
        return singleton(["children", (matchValue = tryHead([(el_8 = Input, createElement(el_8, {
            value: form.Name,
            onChange: (_arg_1, value_1_8) => {
                const v = value_1_8;
                setForm(new NewTitle(v.value));
                patternInput_1[1](isNullOrWhiteSpace(v.value));
            },
        }))]), (matchValue == null) ? defaultOf() : matchValue)]);
    })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])])))), (el_23 = DialogActions, createElement(el_23, createObj(ofArray([["position", "end"], ["style", {
        minWidth: 300,
        justifyContent: "end",
    }], (elems_3 = [(el_17 = Button, createElement(el_17, {
        icon: (el_15 = DismissRegular, createElement(el_15, {})),
        iconPosition: "before",
        children: "Avbryt",
        onClick: (_arg_2) => {
            setIsOpen(false);
            resetForm();
        },
    })), (el_21 = Button, createElement(el_21, {
        icon: (el_19 = AddRegular, createElement(el_19, {})),
        appearance: "primary",
        iconPosition: "before",
        onClick: (_arg_3) => {
            setIsOpen(false);
            let pr_1;
            const pr = startAsPromise(Title.AddTitle(form));
            pr_1 = (pr.then((res) => {
                if (res.tag === 1) {
                    if (res.fields[0].tag === 1) {
                        errorToast(setCtx, "addTitleInvalidName", "Kunne ikke legge til tittel", "Ugyldig navn", undefined);
                    }
                    else {
                        errorToast(setCtx, "addTitleConflict", "Kunne ikke legge til tittel", "Det finnes allerede en tittel med dette navnet", undefined);
                    }
                }
                else {
                    const r = res.fields[0];
                    setTitles(append_1([r], titles));
                    successToast(setCtx, `addTitle${r.Id}Success`, "Suksess", `${r.Name} ble lagt til`);
                }
                return res;
            }));
            void (pr_1.catch((ex) => {
                toastServerError(setCtx, ex);
            }));
            resetForm();
        },
        disabled: isNullOrWhiteSpace(form.Name),
        children: "Legg til",
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])]))))]), (name_2 = DialogBody, createElement(name_2, {
        children: reactApi.Children.toArray(Array.from(props_36)),
    })))], ["children", reactApi_1.Children.toArray(Array.from(elems_4))])]))))], (elemsToUse = ((length(elems_5) <= 2) ? elems_5 : take(2, elems_5)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

function EditTitleDialog(editTitleDialogInputProps) {
    let elems_5, el_4, el_2, el, el_25, elems_4, props_36, el_6, el_13, elems_2, elems_1, el_11, el_23, elems_3, el_17, el_15, el_21, el_19, name_2, elemsToUse;
    const setTitles = editTitleDialogInputProps.setTitles;
    const titles = editTitleDialogInputProps.titles;
    const titleToEdit = editTitleDialogInputProps.titleToEdit;
    const patternInput = reactApi.useState(false);
    const setIsOpen = patternInput[1];
    const setCtx = useCtx()[1];
    const patternInput_2 = reactApi.useState(titleToEdit);
    const setForm = patternInput_2[1];
    const form = patternInput_2[0];
    const dependencies = [titleToEdit];
    reactApi.useEffect(() => {
        setForm(titleToEdit);
    }, dependencies);
    const el_27 = Dialog;
    return createElement(el_27, createObj(ofArray([["open", patternInput[0]], ["onOpenChange", (_arg_1, value_1_1) => {
        setIsOpen(value_1_1.open);
    }], (elems_5 = [(el_4 = DialogTrigger, createElement(el_4, {
        children: (el_2 = Button, createElement(el_2, {
            icon: (el = EditRegular, createElement(el, {})),
            appearance: "transparent",
        })),
    })), (el_25 = DialogSurface, createElement(el_25, createObj(ofArray([["style", {
        maxWidth: 400,
    }], (elems_4 = [(props_36 = ofArray([(el_6 = DialogTitle, createElement(el_6, {
        children: "Rediger tittel",
    })), (el_13 = DialogContent, createElement(el_13, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 5 + "px ",
    }], (elems_2 = [createElement("div", createObj(ofArray([["style", {
        minHeight: 80,
        width: 100 + "%",
    }], (elems_1 = [(el_11 = Field, createElement(el_11, createObj(toList(delay(() => append(singleton(["label", "Navn"]), delay(() => append(isNullOrWhiteSpace(form.Name) ? append(singleton(["validationMessage", "Navn kan ikke være tomt"]), delay(() => singleton(["validationState", "error"]))) : empty(), delay(() => {
        let matchValue, el_8;
        return singleton(["children", (matchValue = tryHead([(el_8 = Input, createElement(el_8, {
            value: form.Name,
            onChange: (_arg_2, value_1_7) => {
                setForm(new Title_1(form.Id, value_1_7.value));
            },
        }))]), (matchValue == null) ? defaultOf() : matchValue)]);
    })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])])))), (el_23 = DialogActions, createElement(el_23, createObj(ofArray([["position", "end"], ["style", {
        minWidth: 300,
        justifyContent: "end",
    }], (elems_3 = [(el_17 = Button, createElement(el_17, {
        icon: (el_15 = DismissRegular, createElement(el_15, {})),
        iconPosition: "before",
        children: "Avbryt",
        onClick: (_arg_3) => {
            setIsOpen(false);
            setForm(titleToEdit);
        },
    })), (el_21 = Button, createElement(el_21, {
        icon: (el_19 = SaveRegular, createElement(el_19, {})),
        appearance: "primary",
        iconPosition: "before",
        onClick: (_arg_4) => {
            setIsOpen(false);
            let pr_1;
            const pr = startAsPromise(Title.UpdateTitle(new UpdatedTitle(form.Id, form.Name)));
            pr_1 = (pr.then((res) => {
                if (res.tag === 1) {
                    switch (res.fields[0].tag) {
                        case 0: {
                            errorToast(setCtx, `updateTitle${titleToEdit.Id}NotFound`, "Kunne ikke oppdatere tittel", "Noe gikk galt", undefined);
                            break;
                        }
                        case 2: {
                            errorToast(setCtx, `updateTitle${titleToEdit.Id}InvalidName`, "Kunne ikke oppdatere tittel", "Ugyldig navn", undefined);
                            break;
                        }
                        default:
                            errorToast(setCtx, `updateTitle${titleToEdit.Id}Conflict`, "Kunne ikke oppdatere tittel", "Det finnes allerede en tittel med dette navnet", undefined);
                    }
                }
                else {
                    const r = res.fields[0];
                    setTitles(map((t) => {
                        if (t.Id === r.Id) {
                            return r;
                        }
                        else {
                            return t;
                        }
                    }, titles));
                    successToast(setCtx, `updateTitle${r.Id}Success`, "Suksess", `${r.Name} ble oppdatert`);
                }
                return res;
            }));
            void (pr_1.catch((ex) => {
                toastServerError(setCtx, ex);
            }));
        },
        disabled: isNullOrWhiteSpace(form.Name),
        children: "Lagre endringer",
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])]))))]), (name_2 = DialogBody, createElement(name_2, {
        children: reactApi.Children.toArray(Array.from(props_36)),
    })))], ["children", reactApi_1.Children.toArray(Array.from(elems_4))])]))))], (elemsToUse = ((length(elems_5) <= 2) ? elems_5 : take(2, elems_5)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

function DeleteTitleDialog(deleteTitleDialogInputProps) {
    let elems_3, el_4, el_2, el, props_39, props_37, el_6, el_12, elems, el_8, el_10, el_18, elems_1, el_16, el_14, el_24, elems_2, el_22, el_20, name, name_2, elemsToUse;
    const setTitles = deleteTitleDialogInputProps.setTitles;
    const titles = deleteTitleDialogInputProps.titles;
    const titleToDelete = deleteTitleDialogInputProps.titleToDelete;
    const patternInput = reactApi.useState(false);
    const setIsOpen = patternInput[1];
    const setCtx = useCtx()[1];
    const el_26 = Dialog;
    return createElement(el_26, createObj(ofArray([["open", patternInput[0]], ["onOpenChange", (_arg, value_1_1) => {
        setIsOpen(value_1_1.open);
    }], (elems_3 = [(el_4 = DialogTrigger, createElement(el_4, {
        children: (el_2 = Button, createElement(el_2, {
            icon: (el = DeleteRegular, createElement(el, {})),
            appearance: "transparent",
        })),
    })), (props_39 = singleton_1((props_37 = ofArray([(el_6 = DialogTitle, createElement(el_6, {
        children: "Er du sikker?",
    })), (el_12 = DialogContent, createElement(el_12, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 5 + "px ",
        marginBottom: 10,
    }], (elems = [(el_8 = WarningFilled, createElement(el_8, {
        primaryFill: tokens.colorStatusWarningForeground1,
        fontSize: 48,
    })), (el_10 = Body1Strong, createElement(el_10, {
        children: `Er du sikker på at du vil slette ${titleToDelete.Name}? Det vil ikke være mulig å angre denne handlingen.`,
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])))), (el_18 = DialogActions, createElement(el_18, createObj(ofArray([["position", "start"], (elems_1 = [(el_16 = Button, createElement(el_16, {
        icon: (el_14 = DismissRegular, createElement(el_14, {})),
        iconPosition: "before",
        children: "Avbryt",
        onClick: (_arg_1) => {
            setIsOpen(false);
        },
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])])))), (el_24 = DialogActions, createElement(el_24, createObj(ofArray([["position", "end"], (elems_2 = [(el_22 = Button, createElement(el_22, {
        icon: (el_20 = DeleteRegular, createElement(el_20, {})),
        iconPosition: "before",
        appearance: "primary",
        children: "Slett",
        onClick: (_arg_2) => {
            setIsOpen(false);
            let pr_1;
            const pr = startAsPromise(Title.DeleteTitle(titleToDelete.Id));
            pr_1 = (pr.then((res) => {
                if (res.tag === 1) {
                    if (res.fields[0].tag === 0) {
                        errorToast(setCtx, `DeleteTitle${titleToDelete.Id}NotFound`, "Kunne ikke slette tittel", "Noe gikk galt", undefined);
                    }
                    else {
                        errorToast(setCtx, `DeleteTitle${titleToDelete.Id}WithUsers`, "Kunne ikke slette tittel", "Titler som har brukere kan ikke slettes", undefined);
                    }
                }
                else {
                    setTitles(titles.filter((t) => (t.Id !== titleToDelete.Id)));
                    successToast(setCtx, `deleteTitle${titleToDelete.Id}Success`, "Suksess", `${titleToDelete.Name} ble slettet`);
                }
                return res;
            }));
            void (pr_1.catch((ex) => {
                toastServerError(setCtx, ex);
            }));
        },
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])]))))]), (name = DialogBody, createElement(name, {
        children: reactApi.Children.toArray(Array.from(props_37)),
    })))), (name_2 = DialogSurface, createElement(name_2, {
        children: reactApi.Children.toArray(Array.from(props_39)),
    })))], (elemsToUse = ((length(elems_3) <= 2) ? elems_3 : take(2, elems_3)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

function Table(tableInputProps) {
    let createTableColumn, createTableColumn_1, tupledArg, elems_2, props_6, el, name_4, el_6;
    const setTitles = tableInputProps.setTitles;
    const allTitles = tableInputProps.allTitles;
    const titles = tableInputProps.titles;
    const patternInput = reactApi.useState(["name", new SortDirection(0, [])]);
    const columns = ofArray([(createTableColumn = createTableColumn_2, createTableColumn({
        columnId: "name",
        compare: (delegateArg, delegateArg_1) => compare(delegateArg.Name, delegateArg_1.Name),
        renderHeaderCell: () => "Navn",
        renderCell: (delegateArg_3) => delegateArg_3.Name,
    })), (createTableColumn_1 = createTableColumn_2, createTableColumn_1({
        columnId: "actions",
        renderHeaderCell: () => "",
        renderCell: (delegateArg_5) => {
            let elems;
            const title_1 = delegateArg_5;
            return createElement("div", createObj(singleton_1((elems = [createElement(EditTitleDialog, {
                titleToEdit: title_1,
                titles: allTitles,
                setTitles: setTitles,
            }), createElement(DeleteTitleDialog, {
                titleToDelete: title_1,
                titles: allTitles,
                setTitles: setTitles,
            })], ["children", reactApi.Children.toArray(Array.from(elems))]))));
        },
    }))]);
    const el_8 = DataGrid;
    return createElement(el_8, createObj(ofArray([dataGrid_items_Z6D8BD2B8(titles), ["columns", toArray(columns)], ["sortable", true], (tupledArg = patternInput[0], ["sortState", {
        sortColumn: unwrap(tupledArg[0]),
        sortDirection: tupledArg[1],
    }]), ["onSortChange", (delegateArg_6, delegateArg_1_1) => {
        const sortState_1 = delegateArg_1_1;
        patternInput[1]([sortState_1.sortColumn, sortState_1.sortDirection]);
    }], ["getRowId", (delegateArg_7) => delegateArg_7.Id], (elems_2 = [(props_6 = singleton_1((el = DataGridRow, createElement(el, {
        children: (delegateArg_8, delegateArg_1_2) => {
            const props_1 = singleton_1(delegateArg_8.renderHeaderCell());
            const name_2 = DataGridHeaderCell;
            return createElement(name_2, {
                children: reactApi.Children.toArray(Array.from(props_1)),
            });
        },
    }))), (name_4 = DataGridHeader, createElement(name_4, {
        children: reactApi.Children.toArray(Array.from(props_6)),
    }))), (el_6 = DataGridBody, createElement(el_6, {
        children: (delegateArg_10) => {
            const trd = delegateArg_10;
            const el_4 = DataGridRow;
            return createElement(el_4, {
                key: trd.rowId,
                children: (delegateArg_9, delegateArg_1_3) => {
                    let elems_1;
                    const tcd_1 = delegateArg_9;
                    const el_2 = DataGridCell;
                    return createElement(el_2, createObj(ofArray([["key", tcd_1.columnId], (elems_1 = [tcd_1.renderCell(trd.item)], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])])));
                },
            });
        },
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])])));
}

export function TitlesView() {
    let elems_5, elems_1, el_12, elems_2, el_10, el_8, el_18, elems_4;
    const patternInput = reactApi.useState(undefined);
    const titles = patternInput[0];
    const setTitles = patternInput[1];
    const patternInput_1 = reactApi.useState("");
    const searchTerm = patternInput_1[0];
    useEffectOnce(() => {
        let pr_1;
        const pr = startAsPromise(Title.GetAllTitles());
        pr_1 = (pr.then((res) => {
            if (res.tag === 1) {
                console.warn(some("Could not fetch titles"));
            }
            else {
                setTitles(res.fields[0]);
            }
            return res;
        }));
        void (pr_1.catch((exn) => {
            console.warn(some(`Could not fetch titles: ${exn.message}`));
        }));
    });
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 2 + "rem",
    }], (elems_5 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    }], (elems_1 = toList(delay(() => {
        let elems, el, el_2;
        return append(singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
        }], (elems = [(el = Title3, createElement(el, {
            children: "Titler",
        })), (el_2 = Caption1, createElement(el_2, {
            children: "Vis og administrer titler",
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let el_6, el_4;
            const matchValue = titles;
            if (matchValue != null) {
                const t_1 = matchValue;
                return singleton(createElement(AddTitleDialog, {
                    titles: t_1,
                    setTitles: (arg) => {
                        setTitles(arg);
                    },
                }));
            }
            else {
                return singleton((el_6 = Button, createElement(el_6, {
                    icon: (el_4 = AddRegular, createElement(el_4, {})),
                    iconPosition: "before",
                    children: "Legg til",
                    appearance: "primary",
                    disabled: true,
                })));
            }
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), (el_12 = Card, createElement(el_12, createObj(ofArray([["orientation", "horizontal"], ["style", {
        width: 100 + "%",
        display: "flex",
        justifyContent: "space-between",
    }], (elems_2 = [(el_10 = Input, createElement(el_10, {
        contentBefore: (el_8 = SearchRegular, createElement(el_8, {})),
        placeholder: "Søk etter tittel...",
        value: searchTerm,
        onChange: (_arg_1, value_1_7) => {
            const v = value_1_7;
            patternInput_1[1](isNullOrWhiteSpace(v.value) ? "" : v.value);
        },
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])])))), (el_18 = Card, createElement(el_18, createObj(ofArray([["style", {
        width: 100 + "%",
    }], (elems_4 = toList(delay(() => {
        let el_16, elems_3;
        if (titles != null) {
            const t_2 = titles;
            const filtered = t_2.filter((title) => (title.Name.toLocaleLowerCase().indexOf(searchTerm.toLocaleLowerCase()) >= 0));
            return singleton(createElement(Table, {
                titles: filtered,
                allTitles: t_2,
                setTitles: (arg_1) => {
                    setTitles(arg_1);
                },
            }));
        }
        else {
            return singleton((el_16 = Skeleton, createElement(el_16, createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                gap: 8 + "px ",
                width: 100 + "%",
            }], (elems_3 = toList(delay(() => map_1((_arg_2) => {
                const el_14 = SkeletonItem;
                return createElement(el_14, {
                    style: {
                        height: 48,
                    },
                    animation: "wave",
                    shape: "rectangle",
                });
            }, toList(rangeDouble(1, 1, 5))))), ["children", reactApi_1.Children.toArray(Array.from(elems_3))])])))));
        }
    })), ["children", reactApi_1.Children.toArray(Array.from(elems_4))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

//# sourceMappingURL=Titles.jsx.map
